export * from './iconFontAwesomeAnimalsHippo';
export * from './iconFontAwesomeAnimalsFeather';
export * from './iconFontAwesomeAnimalsFish';
export * from './iconFontAwesomeAnimalsDragon';
export * from './iconFontAwesomeAnimalsOtter';
export * from './iconFontAwesomeAnimalsKiwiBird';
export * from './iconFontAwesomeAnimalsWorm';
export * from './iconFontAwesomeAnimalsSpider';
export * from './iconFontAwesomeAnimalsShrimp';
export * from './iconFontAwesomeAnimalsShieldDog';
export * from './iconFontAwesomeAnimalsShieldCat';
export * from './iconFontAwesomeAnimalsPaw';
export * from './iconFontAwesomeAnimalsMosquito';
export * from './iconFontAwesomeAnimalsLocust';
export * from './iconFontAwesomeAnimalsHorseHead';
export * from './iconFontAwesomeAnimalsHorse';
export * from './iconFontAwesomeAnimalsFrog';
export * from './iconFontAwesomeAnimalsFishFins';
export * from './iconFontAwesomeAnimalsFeatherPointed';
export * from './iconFontAwesomeAnimalsDove';
export * from './iconFontAwesomeAnimalsDog';
export * from './iconFontAwesomeAnimalsCrow';
export * from './iconFontAwesomeAnimalsCow';
export * from './iconFontAwesomeAnimalsCat';
export * from './iconFontAwesomeAnimalsBugs';
